import { IJornadaEtapa } from "../../../Interfaces/Geral/GestaoDeCadastro/JornadaEtapa/JornadaEtapaInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function CadastrarJornadaEtapaService(data: IJornadaEtapa) {
    return Service(
        Axios.post(`/home/etapajornada/cadastraretapadajornada`, data)
    );
}

export async function AtualizarJornadaEtapaService(data: IJornadaEtapa) {
    return Service(
        Axios.put(`/home/etapajornada/atualizaretapadajornada`, data)
    );
}

export async function ListarJornadaEtapaService(FL_ATIVO?: boolean) {
    return Service(
        Axios.get<Array<IJornadaEtapa>>(
            `/home/etapajornada/listaretapasdajornada?FL_ATIVO=${
                FL_ATIVO ?? true
            }`
        )
    );
}

export async function ExcluirJornadaEtapaService(idEtapaJornada: number) {
    return Service(
        Axios.delete(
            `/home/etapajornada/removeretapadajornada?idEtapaJornada=${idEtapaJornada}`
        )
    );
}

export async function GetJornadaEtapaService(idEtapaJornada: number) {
    return Service(
        Axios.get<IJornadaEtapa>(
            `/home/etapajornada/getetapadajornada?idEtapaJornada=${idEtapaJornada}`
        )
    );
}

export async function VincularEtapaJornadaService(
    idUnidade: number,
    idConta: number,
    idEtapaJornada: number
) {
    return Service(
        Axios.post<IJornadaEtapa>(
            `/home/etapajornada/vincularetapajornadaavenda?ID_UNIDADE=${idUnidade}&ID_CONTA=${idConta}&ID_ETAPA_JORNADA=${idEtapaJornada}`
        )
    );
}
